import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-button button-cancel pt usn action-button" }

import useCustomIcon from '@/utilities/composables/useCustomIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonIcon',
  props: {
  icon: {
    type: String,
    required: true,
    default: '',
  },
},
  setup(__props) {

const { iconPath, getCustomIconStyle } = useCustomIcon();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("em", {
      style: _normalizeStyle(_unref(getCustomIconStyle)(_unref(iconPath)(__props.icon))),
      class: "custom-icons card-action-icon bg-icon-default group-hover:bg-icon-hover"
    }, null, 4)
  ]))
}
}

})